import { Accordion, AccordionTitle, AccordionContent, Box, Text } from '@customerio/pluma-components/react';
import type { SupportFormDiagnostics } from '../types';
import * as styles from './support-form-modal.css';

type DiagnosticsDisclosureProps = {
  diagnostics: SupportFormDiagnostics;
};

/**
 * Tells the customer a diagnostic snapshot will travel with their ticket, and lets them read it.
 *
 * Collapsed by default and kept out of the description field: the point of attaching measurements
 * is that the customer only has to write the one sentence the numbers cannot supply. It is
 * disclosed rather than hidden because they are about to send it.
 */
export function DiagnosticsDisclosure({ diagnostics }: DiagnosticsDisclosureProps) {
  return (
    <Accordion variant="bordered">
      <AccordionTitle>
        <Text size="sm">{diagnostics.label} diagnostics will be attached</Text>
      </AccordionTitle>
      <AccordionContent>
        <Box className={styles.diagnosticsSummary}>
          <Text size="xs" color="secondary">
            {diagnostics.summary}
          </Text>
        </Box>
      </AccordionContent>
    </Accordion>
  );
}
